import { render, staticRenderFns } from "./ZhanhuiDdtcBlock.vue?vue&type=template&id=3f453ecc&scoped=true"
import script from "./ZhanhuiDdtcBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiDdtcBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiDdtcBlock.vue?vue&type=style&index=0&id=3f453ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f453ecc",
  null
  
)

export default component.exports